import { AppEnvironment, defineAppEnvironment } from '../app/core/config/app-environment';

export const environment = defineAppEnvironment({
  production: false,
  appName: 'Lumen Hospitality DPSK DEV',
  apiBaseUrl: 'https://hospitality.guglielmo.dev/api',
  branding: {
    companyName: 'Guglielmo',
    version: '1.0.6-DEV',
    logoPath: 'brand/guglielmo-logo.png'
  },
  /*auth: {
    mode: 'mock',
    keycloakUrl: 'http://localhost:8080',
    realm: 'lumen-hospitality',
    clientId: 'dashboard-web',
    redirectUri: './'
  },*/
  auth: {
    mode: 'keycloak',
    keycloakUrl: 'https://cyberhall.guglielmo.dev/auth',
    realm: 'LumenNG-Hospitality',
    clientId: 'dashboard-client',
    redirectUri: './',
    logoutRedirectUri: './auth/login'
  },
  demoUser: {
    id: 'demo-luca-gentili',
    name: 'Luca Gentili',
    email: 'luca.gentili@lumenhospitality.demo',
    role: 'platform-admin',
    tenantIds: ['aurora-collection', 'north-harbor-venues'],
    locationIds: ['palazzo-amare-roma', 'lago-blu-resort', 'officine-forum-milano']
  },
  wifi: {
    primarySsid: 'LUMEN-HOSPITALITY',
    eventSsid: 'LUMEN-EVENTS'
  }
} satisfies AppEnvironment);
